import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./playlist.css";

export default class Playlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoSelections: [],
    };

    this.handleOnDragEnd = this.handleOnDragEnd.bind(this);
    this.changePlayingItem = this.changePlayingItem.bind(this);
    this.playPauseCurrentItem = this.playPauseCurrentItem.bind(this);
  }

  componentDidMount() {
    if (this.props.playerContext) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.playerContext !== prevProps.playerContext &&
      this.props.playerContext
    ) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  playerStateChanged(state) {
    this.setState({ videoSelections: state.videoToGpsFileMapping });
    if (this.awaitPlay) {
      //await play is used when requesting a change of playlist index - requestPlay can't be called until the video track has changed
      this.awaitPlay = false;
      this.props.playerContext.requestPlay();
    }
  }

  handleOnDragEnd(result) {
    if (!result.destination || result.source.index === result.destination.index)
      return;
    const items = [...this.state.videoSelections];
    const playingItem = items[this.props.playerContext.playlistIndex];
    const [reorderItems] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItems);

    this.setState({ videoSelections: items });
    this.props.playerContext.setPlayerFiles(
      items,
      items.indexOf(playingItem),
      false
    );
  }

  changePlayingItem(e) {
    this.props.playerContext.setPlaylistIndex(
      parseInt(e.currentTarget.dataset.id)
    );
    this.awaitPlay = true;
  }

  playPauseCurrentItem() {
    this.props.playerContext.playing
      ? this.props.playerContext.requestPause()
      : this.props.playerContext.requestPlay();
  }

  render() {
    return (
      <div className="playlistContainer">
        {this.state.videoSelections.length > 0 ? (
          <DragDropContext onDragEnd={this.handleOnDragEnd}>
            <Droppable droppableId="videoSelections">
              {(provided) => (
                <ul
                  className="videoSelectionsList"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {this.state.videoSelections.map(({ video, gps }, index) => {
                    return (
                      <Draggable key={video} draggableId={video} index={index}>
                        {(provided) => (
                          <li
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={
                              index === this.props.playerContext.playlistIndex
                                ? "playing"
                                : null
                            }
                          >
                            <div>
                              <p>{`Video: '${video}'`}</p>
                              <p>{`GPS: '${gps}'`}</p>
                            </div>
                            {index !==
                            this.props.playerContext.playlistIndex ? (
                              <button
                                className="button light"
                                type="button"
                                data-id={index}
                                onClick={this.changePlayingItem}
                              >
                                <FontAwesomeIcon icon={faPlay} size="lg" />
                              </button>
                            ) : (
                              <button
                                className="button light"
                                type="button"
                                onClick={this.playPauseCurrentItem}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    this.props.playerContext.playing
                                      ? faPause
                                      : faPlay
                                  }
                                  size="lg"
                                />
                              </button>
                            )}
                          </li>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </ul>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <div>Video(s) not yet loaded</div>
        )}
      </div>
    );
  }
}
